import { Currency, UNKNOWN_CURRENCY } from '../config/i18nConfig'
import { useEffect, useMemo, useState } from 'react'
import { getI18NName } from '../components/Combobox/i18n/I18NCombobox'
import { useTranslation } from 'react-i18next'
import useCurrencies from './useCurrencies'

type ReturnProps = {
    currency: Currency
    currencyName: string
    setAlpha: (alpha: string) => void
}

export default function useCurrency(alpha?: string, currency?: Currency): ReturnProps {
    const { i18n } = useTranslation()

    const [_alpha, setAlpha] = useState<string>(alpha)
    const { loaded, currencies } = useCurrencies()
    const _currency = useMemo(
        () =>
            currency || (_alpha && (currencies || []).find(currency => currency.alpha === _alpha)) || UNKNOWN_CURRENCY,
        [_alpha, loaded, currencies],
    )
    const currencyName = useMemo<string>(() => {
        return getI18NName(_currency, i18n.language)
    }, [_currency, i18n.language])

    useEffect(() => {
        setAlpha(alpha)
    }, [alpha])

    return { currency: _currency, currencyName, setAlpha }
}
